import {
    GET_DEFINITION_REQUEST,
    GET_DEFINITION_SUCCESS,
    GET_DEFINITION_FAILURE
} from '../actions';
const initialState = {};

const GetDefinitionReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DEFINITION_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_DEFINITION_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_DEFINITION_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default GetDefinitionReducer;